// extracted by mini-css-extract-plugin
export default {"gallery":"c-p_fn","gallery__header":"c-p_fo","gallery__thumbs":"c-p_fp"};